import { IUser } from '@/pages/Users/users.types.ts'
import { useEffect, useMemo, useState } from 'react'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import usersApi from '@/pages/Users/users.api.ts'
import { IOption } from '@/types/global.ts'
import MultiDropdownInput from '@/shared/Inputs/MultiDropdownInput'
import userUtils from '@/pages/User/user.utils'

interface IProps {
  selectedUsersIds: Array<IUser['id']>
  onChange: (val: Array<IUser['id']>, name?: string) => void
  name: string
}

const UserMultiDropdownInput = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [usersList, setUsersList] = useState<IUser[]>([])

  const options: IOption<IUser['id']>[] = useMemo(() => {
    return usersList.map((user) => ({ title: userUtils.getFullName(user.userInfo), value: user.id }))
  }, [usersList])

  useEffect(() => {
    wait(usersApi.list({ limit: 1000 }), (resp) => {
      if (resp.status === 'success') {
        setUsersList(resp.body.items)
      }
    })
  }, [])

  return (
    <MultiDropdownInput
      type="input"
      selectedOptions={props.selectedUsersIds}
      options={options}
      title="Выберите пользователей"
      onSelect={props.onChange}
      name={props.name}
      loading={loading}
    />
  )
}

export default UserMultiDropdownInput
